import React from 'react';

import { Workflow, ArrowRight } from 'lucide-react';
import './HowWeWork.scss';

// Custom monoline SVG illustrations for each step
const stepIllustrations = {
    consult: (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="24" cy="16" r="6" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M14 38c0-5.5 4.5-10 10-10s10 4.5 10 10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <rect x="30" y="6" width="14" height="10" rx="5" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M34 11h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <rect x="4" y="20" width="14" height="10" rx="5" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M8 25h6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    ),
    plan: (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect x="8" y="4" width="32" height="40" rx="3" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M16 14h16M16 22h16M16 30h10" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="36" cy="36" r="8" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M33 36l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    ),
    deploy: (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M24 6l16 8v20l-16 8-16-8V14l16-8z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
            <path d="M8 14l16 8 16-8" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
            <path d="M24 22v20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <path d="M16 10l16 8" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.5"/>
        </svg>
    ),
    support: (
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M10 26V22a14 14 0 0128 0v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <rect x="6" y="24" width="6" height="12" rx="3" stroke="currentColor" strokeWidth="1.5"/>
            <rect x="36" y="24" width="6" height="12" rx="3" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M42 34v2a4 4 0 01-4 4h-8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="28" cy="40" r="2" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M18 14a3 3 0 013-3h6a3 3 0 013 3" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" opacity="0.4"/>
        </svg>
    ),
};

const HowWeWork = () => {
    const steps = [
        {
            number: '01',
            key: 'consult',
            title: 'Consult',
            description: 'Understand your requirements, budget, and compliance needs through a quick discovery call.',
        },
        {
            number: '02',
            key: 'plan',
            title: 'Source',
            description: 'Source the right products from authorized distributors and provide competitive, transparent quotes.',
        },
        {
            number: '03',
            key: 'deploy',
            title: 'Deliver',
            description: 'Place orders, track fulfillment, and deliver, configuring where needed, on schedule.',
        },
        {
            number: '04',
            key: 'support',
            title: 'Support',
            description: 'Ongoing support, warranty handling, returns, and reorders to keep you running.',
        },
    ];

    return (
        <section className="jk-howwework">
            <div className="jk-howwework__container">
                    <div className="jk-howwework__header">
                        <span className="jk-section-label">
                            <Workflow size={16} />
                            Our Process
                        </span>
                        <h2 className="jk-howwework__title">
                            How We
                            <span className="jk-howwework__title-highlight"> Work</span>
                        </h2>
                        <p className="jk-howwework__subtitle">
                            A proven four-step approach that delivers results on time, every time.
                        </p>
                    </div>

                <div className="jk-howwework__grid">
                    {steps.map((step, index) => (
                            <div key={index} className="jk-howwework__step">
                                <div className="jk-howwework__step-number">
                                    <span>{step.number}</span>
                                    <span className="jk-howwework__step-dot" />
                                </div>
                                <div className="jk-howwework__step-illustration">
                                    {stepIllustrations[step.key]}
                                </div>
                                <h3 className="jk-howwework__step-title">{step.title}</h3>
                                <p className="jk-howwework__step-desc">{step.description}</p>

                                {index < steps.length - 1 && (
                                    <div className="jk-howwework__connector" aria-hidden="true">
                                        <span className="jk-howwework__connector-line" />
                                        <ArrowRight size={16} className="jk-howwework__connector-arrow" />
                                    </div>
                                )}
                            </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowWeWork;
